export const LOGIN_REQUEST  = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS  = 'LOGIN_SUCCESS';
export const LOGIN_FAIL     = 'LOGIN_FAIL';

export const ME_REQUEST     = 'ME_REQUEST';
export const ME_SUCCESS     = 'ME_SUCCESS';